export const UseCaseNominationTitleSVG = () => (
  <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path
      d="M33.6383 17.7784V5.00065C33.6383 4.08018 32.8922 3.33398 31.9717 3.33398H8.63835C7.71787 3.33398 6.97168 4.08018 6.97168 5.00065V35.0006C6.97168 35.9211 7.71787 36.6673 8.63835 36.6673H20.305"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.6387 13.334H25.3053"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path d="M13.6387 20H20.3053" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <path
      d="M38.0828 24.4453H33.7494L32.416 27.8788C33.9032 28.1806 35.1507 29.1426 35.8394 30.4455L38.0828 24.4453Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.083 24.4453H24.7495L26.9929 30.4455C27.6817 29.1426 28.9292 28.1806 30.4163 27.8788L29.083 24.4453Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M36.4163 33.2228C36.4163 35.9843 34.1777 38.2229 31.4162 38.2229C28.6546 38.2229 26.416 35.9843 26.416 33.2228C26.416 32.38 26.6245 31.586 26.9927 30.8894C27.6815 29.5865 28.929 28.6246 30.4161 28.3227C30.7392 28.2571 31.0737 28.2227 31.4162 28.2227C31.7586 28.2227 32.0931 28.2571 32.4162 28.3227C33.9034 28.6246 35.1509 29.5865 35.8396 30.8894C36.2078 31.586 36.4163 32.38 36.4163 33.2228Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CompetitionTracksTitleSVG = () => (
  <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.2331 13.3333C33.5342 13.3333 35.3997 11.4678 35.3997 9.16667C35.3997 6.86548 33.5342 5 31.2331 5C28.9319 5 27.0664 6.86548 27.0664 9.16667C27.0664 11.4678 28.9319 13.3333 31.2331 13.3333Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M9.56657 34.9993C11.8677 34.9993 13.7332 33.1338 13.7332 30.8327C13.7332 28.5315 11.8677 26.666 9.56657 26.666C7.26539 26.666 5.3999 28.5315 5.3999 30.8327C5.3999 33.1338 7.26539 34.9993 9.56657 34.9993Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M31.2331 13.3333V29.5868C31.2331 32.5764 28.8095 35 25.8199 35C22.8302 35 20.4067 32.5764 20.4067 29.5868V10.4202C20.4067 7.42667 17.98 5 14.9866 5C11.9931 5 9.56641 7.42667 9.56641 10.4202V26.6667"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PreparationCommitteeTitleSVG = () => (
  <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6327 16.6667C19.8543 16.6667 22.466 14.055 22.466 10.8333C22.466 7.61168 19.8543 5 16.6327 5C13.411 5 10.7993 7.61168 10.7993 10.8333C10.7993 14.055 13.411 16.6667 16.6327 16.6667Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.9722 5.83398C29.6662 6.85473 30.7992 8.71207 30.7992 10.834C30.7992 12.9559 29.6662 14.8132 27.9722 15.834"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.13281 34.0007V35.0007H29.1328V34.0007C29.1328 30.267 29.1328 28.4002 28.4062 26.9741C27.7671 25.7197 26.7471 24.6997 25.4927 24.0606C24.0666 23.334 22.1998 23.334 18.4661 23.334H14.7995C11.0658 23.334 9.19898 23.334 7.77288 24.0606C6.51846 24.6997 5.49859 25.7197 4.85944 26.9741C4.13281 28.4002 4.13281 30.267 4.13281 34.0007Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.4658 35.0005V34.0005C37.4658 30.2669 37.4658 28.4 36.7392 26.974C36.1 25.7195 35.0801 24.6997 33.8257 24.0605"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const RankingCriteriaTitleSVG = () => (
  <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.3665 15H3.5332V35H14.3665V15Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M25.1995 5H14.3662V35H25.1995V5Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M36.033 21.666H25.1997V34.9993H36.033V21.666Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AwardingTitleSVG = () => (
  <svg viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.5991 25.0007C26.122 25.0007 30.5991 20.3918 30.5991 14.7066V3.33398H10.5991V14.7066C10.5991 20.3918 15.0763 25.0007 20.5991 25.0007Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5993 17.4993V9.16602H3.93262C3.93262 14.7216 7.26595 17.4993 10.5993 17.4993Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.5991 17.4993V9.16602H37.2658C37.2658 14.7216 33.9325 17.4993 30.5991 17.4993Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5991 25.5312L20.5991 29.7866"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.0991 35L16.1741 30H24.8012L28.0991 35H13.0991Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);

export const RightToppinkSVG = () => (
  <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H20.4V20.4L0 0Z" fill="#FF18B4" />
  </svg>
);

export const ChanpionshipTimeDot1SVG = () => (
  <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="5" fill="#152381" />
  </svg>
);
export const ChanpionshipTimeDot2SVG = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" fill="white" stroke="#0F5EF7" stroke-width="2" />
    <circle cx="8" cy="8" r="3" fill="#0F5EF7" />
  </svg>
);

export const ChanpionshipTimeDot3SVG = () => (
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="5" fill="white" stroke="#D9DEE3" stroke-width="2" />
  </svg>
);
export const ChanpionshipCloseSVG = () => (
  <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.83398 2.83203L14.1673 14.1654"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.83398 14.1654L14.1673 2.83203"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ChanpionshipRightSVG = () => (
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25 16.5L13.75 11L8.25 5.5" stroke="white" stroke-width="1.5" />
  </svg>
);
